/**
 * Role for admin-panel RBAC. Prefer `adminUserRole`; fall back to `adminUserDetails.role`
 * so UI stays correct when login stored details but omitted the dedicated role key.
 */
export function getAdminPanelRole() {
  if (typeof window === "undefined") return "";
  const direct = localStorage.getItem("adminUserRole");
  if (direct != null && String(direct).trim() !== "") {
    return String(direct).trim().toLowerCase();
  }
  try {
    const raw = localStorage.getItem("adminUserDetails");
    if (!raw) return "";
    const parsed = JSON.parse(raw);
    const r = parsed?.role;
    if (r == null) return "";
    return String(r).trim().toLowerCase();
  } catch {
    return "";
  }
}

/** Canonical role string as stored at login (e.g. "CSR Team Lead"). */
export function getAdminPanelRoleDisplay() {
  if (typeof window === "undefined") return "Admin";
  const direct = localStorage.getItem("adminUserRole");
  if (direct != null && String(direct).trim() !== "") {
    return String(direct).trim();
  }
  try {
    const raw = localStorage.getItem("adminUserDetails");
    if (!raw) return "Admin";
    const parsed = JSON.parse(raw);
    const r = parsed?.role ?? parsed?.Role;
    if (r == null || String(r).trim() === "") return "Admin";
    return String(r).trim();
  } catch {
    return "Admin";
  }
}

const ROLE_LABELS = {
  Admin: "Admin",
  Developer: "Developer",
  Author: "Author",
  CSR: "CSR",
  "CSR Team Lead": "Team Lead",
  "Chat Support": "Chat Support",
  Sales: "Sales",
  "Sales Team Lead": "Sales Team Lead",
};

const ROLE_BADGE_STYLES = {
  Admin: "bg-slate-100 text-slate-700 border-slate-200",
  Developer: "bg-violet-100 text-violet-800 border-violet-200",
  Author: "bg-pink-100 text-pink-800 border-pink-200",
  CSR: "bg-teal-100 text-teal-800 border-teal-200",
  "CSR Team Lead": "bg-indigo-100 text-indigo-800 border-indigo-200",
  "Chat Support": "bg-cyan-100 text-cyan-800 border-cyan-200",
  Sales: "bg-amber-100 text-amber-800 border-amber-200",
  "Sales Team Lead": "bg-orange-100 text-orange-800 border-orange-200",
};

export function formatAdminRoleLabel(role) {
  const key = role?.trim() || "Admin";
  return ROLE_LABELS[key] || key;
}

export function adminRoleBadgeClass(role) {
  const key = role?.trim() || "Admin";
  return ROLE_BADGE_STYLES[key] || "bg-gray-100 text-gray-700 border-gray-200";
}

/** App user profile edit on User Profiles (Admin, Developer, CSR, CSR Team Lead). */
export function canEditAppUserProfile(roleKey = null) {
  const r = roleKey ?? getAdminPanelRole();
  return (
    r === "admin" ||
    r === "developer" ||
    r === "csr" ||
    r === "csr team lead"
  );
}
